<template>
  <div class="bodywarp">
    <el-card class="box-card boxcard">
      <div slot="header" class="clearfix">
        <b><i class="el-icon-s-unfold"></i>送货单制作</b>
      </div>
      <div class=' contijiao wkbmf loaded' v-if="tableRadio.ciscommit=='是'">
        <div class='stamp'> </div>
      </div>
      <div style="width:100%; height:55px">
        <div class="pull-right">
          <el-button type="success" size="medium" plain @click="myorder"
            :disabled="tableRadio.ciscommit=='是'">我的送货单</el-button>
          <!-- <el-button type="warning" size="medium" @click="SaveSHInfo">保存</el-button> -->
          <Debounce :time='300' :isDebounce="1">
            <el-button type="primary" plain @click.native="SaveSHInfo()" size="medium">保存</el-button>
          </Debounce>
          <Debounce :time='300' :isDebounce="1">
            <el-button type="primary" plain @click.native="CommitSHInfo()" size="medium"
              :disabled="tableRadio.ciscommit=='是'">提交</el-button>
          </Debounce>
          <!-- <el-button type="primary" size="medium" @click="CommitSHInfo()">提交</el-button> -->
          <el-button type="warning" size="medium" @click="printpage()" plain
            :disabled="tableRadio.ciscommit!='是'">打印</el-button>
          <el-button type="primary" size="medium" @click="UnCommitSHInfo()"
            :disabled="tableRadio.ciscommit!='是'">撤销提交</el-button>
          <el-button type="danger" size="medium" @click="DeleteSHInfo"
            :disabled="tableRadio.ciscommit=='是'">删除</el-button>
          <el-button type="info" plain size="medium" @click="returnpage">返回</el-button>
        </div>
      </div>
      <div style="width:100%">
        <el-form :inline="true" :model="tableRadio" class="demo-form-inline itemwidth infodata" label-width="100px">
          <el-form-item label="公司名称">
            <el-select v-model="tableRadio.ccorpcode" clearable placeholder="请选择" v-if="tableRadio.id==''">
              <el-option v-for="item in selectlist" :key="item.ccorpcode" :label="item.ccorpname"
                :value="item.ccorpcode"></el-option>
            </el-select>
            <el-select v-model="tableRadio.ccorpcode" clearable placeholder="请选择" v-if="tableRadio.id!=''" disabled>
              <el-option v-for="item in selectlist" :key="item.ccorpcode" :label="item.ccorpname"
                :value="item.ccorpcode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="送货日期">
            <el-date-picker type="date" v-model="tableRadio.ddeliverytime" value-format="yyyy-MM-dd"
              placeholder="送货日期"></el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="送货单号">
          <el-input v-model="tableRadio.ccode" placeholder="送货单号"></el-input></el-form-item> -->
          <el-form-item label="车牌号">
            <el-input v-model="tableRadio.ccarcode" placeholder="车牌号"></el-input>
          </el-form-item>
          <el-form-item label="预计到货时间">
            <el-date-picker type="date" v-model="tableRadio.dyjdeliverytime" value-format="yyyy-MM-dd"
              placeholder="预计到货时间"></el-date-picker>
          </el-form-item>
          <el-form-item label="制单日期">
            <el-date-picker type="date" v-model="tableRadio.ddate" value-format="yyyy-MM-dd"
              placeholder="送货日期"></el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="供应商">
            <el-input v-model="tableRadio.cvenname" placeholder="供应商" disabled></el-input>
          </el-form-item>
          <el-form-item label="供应商编号">
            <el-input v-model="tableRadio.cvencode" placeholder="供应商编号" disabled></el-input>
          </el-form-item>
          <el-form-item label="送达方">
            <el-select v-model="tableRadio.cdeliveryname" clearable placeholder="请选择" disabled>
              <el-option v-for="item in selectlist" :key="item.cpasturecode" :label="item.cpasturename" :value="item.cpasturecode"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="备注" class="cremark">
            <el-input v-model="tableRadio.cremark" placeholder="备注"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card boxcard" style="min-height: calc(100% - 300px)">
      <div slot="header" class="clearfix" v-if="tableRadio.ciscommit!='是'">
        <span style="color:red">*校验单上传支持{{typeaccept}}格式</span>
      </div>
      <div class="text item text-center">

        <el-table :data="tableorder" style="width: 100%" border max-height="420"
          :cell-style="{ padding: '7px 0',textAlign: 'center' }" class="tableinput"
          :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }">
          <!-- <el-table-column prop="chtcode" label="合同号" width="100"></el-table-column> -->
          <!-- <el-table-column prop="cht_id" label="合同行ID" min-width="110"></el-table-column>  -->
          <!-- <el-table-column prop="csrminvcode" label="SRM物料编码" width="120"></el-table-column>
        <el-table-column prop="csapinvcode" label="SAP物料编码" width="110"></el-table-column> -->
          <el-table-column prop="cinvname" label="物料名称" width="160"></el-table-column>
          <!-- <el-table-column label="收货状态" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.cinstore=='是'">已收货</span>
              <span v-else>未收货</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="cspecification" label="规格" width="60"></el-table-column>
          <el-table-column prop="cunit" label="计量单位" width="75"></el-table-column>
          <el-table-column prop="cordercode" label="订单号" width="100"></el-table-column>
          <el-table-column prop="cdeliveryname_det" label="送达方" width="150"></el-table-column>
          <el-table-column prop="cjhname" label="仓库" width="100"></el-table-column>
          <el-table-column prop="irkqty" label="已送货数量" width="100"></el-table-column>
          <el-table-column prop="inumber" label="送货数量" width="100"></el-table-column>
          <el-table-column prop="inownum" label="本次送货数量" width="130">
            <template slot-scope="scope">
              <span v-if="tableRadio.ciscommit=='是'">{{scope.row.inownum}}</span>
              <el-input size="small" v-else v-model="scope.row.inownum" placeholder="本次送货数量"
                oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g,'$1')" class="inputmin"></el-input>

            </template>
          </el-table-column>
          <el-table-column label="送货批次" width="140">
            <template slot-scope="scope">
              <span v-if="tableRadio.ciscommit=='是'">{{scope.row.cdeliverylot}}</span>
              <el-input size="small" v-else v-model="scope.row.cdeliverylot" placeholder="送货批次"
                class="inputmin"></el-input>

            </template>
          </el-table-column>
          <el-table-column label="生产日期" min-width="150">
            <template slot-scope="scope">
              <span v-if="tableRadio.ciscommit=='是'">{{scope.row.dproducdate}} </span>
              <el-date-picker v-else v-model="scope.row.dproducdate" type="date" key="day" placeholder="生产日期"
                value-format="yyyy-MM-dd"></el-date-picker>

            </template>
          </el-table-column>
          <el-table-column label="保质期" min-width="160">
            <template slot-scope="scope">
              <span v-if="tableRadio.ciscommit=='是'">{{scope.row.dshelfdate}}</span>
              <el-date-picker type="date" v-else v-model="scope.row.dshelfdate" value-format="yyyy-MM-dd"
                placeholder="保质期"></el-date-picker>

            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" v-if="tableRadio.ciscommit!='是'" fixed="right">
            <template slot-scope="scope">
              <el-upload action="#" :ref="'uploadFail'+scope.$index" style="display:inline-block;margin:0 10px"
                :show-file-list="false" v-if="scope.row.cisuploadtest=='是'&& tableRadio.ciscommit!='是'"
                :before-upload="function (file) { return brforeUploadreImportFail(file, scope.row)}"
                :auto-upload="false"
                :on-change="function (file, fileList) { return handleChangeFail(file, scope.row,scope.$index)}"
                :file-list="fileListFail" :accept="typeaccept">
                <el-button type="success" size="mini">上传检验单</el-button>
              </el-upload>
              <!-- <el-button size="mini" type="success" v-if="scope.row.cisuploadtest=='是'" @click="del(scope.row, scope.$index)">上传校验单</el-button> -->
              <el-button size="mini" type="danger" @click="del(scope.row, scope.$index)"
                v-if="scope.row.cinstore=='是'|| tableRadio.ciscommit!='是'">删除</el-button>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <div class="text item text-center" id="export" style="display:none">
        <h3 class="text-center">送货单打印</h3>
        <table cellpadding="0" cellspacing="0" class="tableshd">
          <thead>
            <tr>
              <th>物料名称</th>
              <th>收货状态</th>
              <th>规格</th>
              <th>采购计量单位</th>
              <th>订单号</th>
              <th>送货数量</th>
              <th>送货批次</th>
              <th>生产日期</th>
              <th>保质期</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row,i) in tableorder" :key="i">
              <td>{{row.cinvname}} </td>
              <td>
                <span v-if="row.cinstore=='是'">已收货</span>
                <span v-else>未收货</span>
              </td>
              <td>{{row.cspecification}} </td>
              <td>{{row.cunit}} </td>
              <td>{{row.cordercode}} </td>
              <td>{{row.inumber}} </td>
              <td>{{row.cdeliverylot}} </td>
              <td>
                {{row.dproducdate}}
              </td>
              <td>
                {{row.dshelfdate}}
              </td>
            </tr>
          </tbody>
        </table>

      </div>
    </el-card>
    <el-dialog :visible.sync="dialogFormVisible" :append-to-body="true" customClass="way assoformwarp">
      <el-form ref="assoruleForm" :model="qualiform" :inline="true" label-width="60px">
        <el-form-item label="日期:" prop="dfilestarttime">
          <el-date-picker style="width:300px;" v-model="timeval" type="daterange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input v-model="formInline.csapcode" placeholder="订单号"></el-input>
        </el-form-item>
        <el-form-item label="物料">
          <el-input v-model="formInline.cinvname_list" placeholder="物料"></el-input>
        </el-form-item>
        <el-form-item prop="dfilestarttime" label-width="0">
          <!-- <el-button type="primary" @click="GetOrderList()">查询</el-button> -->
          <Debounce :time='300' :isDebounce="1">
            <el-button type="primary" @click.native="GetOrderList()" size="medium">查询</el-button>
          </Debounce>
        </el-form-item>
      </el-form>
      <el-table :data="orderlist" style="width: 100%" max-height="360px" border :cell-style="{ padding: '7px 0' }"
        tooltip-effect="dark" @selection-change="handleSelectionChange" @row-click="handleRowClick" ref="multipleTable">
        <el-table-column type="selection" width="40"></el-table-column>
        <!-- <el-table-column prop="chtcode_list" label="合同号" width="140"></el-table-column>

         <el-table-column prop="chtid_list" label="合同行ID" width="95"></el-table-column>   -->
        <!-- <el-table-column prop="csrminvcode_list" label="SRM物料编码" min-width="160"></el-table-column>  -->
        <!-- <el-table-column prop="csapinvcode_list" label="SAP物料编码" width="160"></el-table-column>  -->
        <!-- <el-table-column prop="ddate" label="SRM物料编码" min-width="160"></el-table-column>  -->

        <el-table-column prop="cinvname_list" label="物料名称" min-width="200"></el-table-column>
        <el-table-column prop="cinvstd" label="规格" width="60"></el-table-column>
        <el-table-column prop="cinvunit" label="计量单位" width="90"></el-table-column>
        <el-table-column prop="csapcode" label="订单号" width="120"></el-table-column>
        <el-table-column prop="irkqty" label="已送货数量" width="100"></el-table-column>
        <el-table-column prop="inum" label="送货数量" min-width="95"></el-table-column>
        <el-table-column prop="ddhdate" label="要货时间" width="100"></el-table-column>
        <el-table-column prop="iplancarnum" label="要货车次" width="100"></el-table-column>
        <el-table-column prop="ifactcarnum" label="已送货车次" width="100"></el-table-column>
        <el-table-column prop="cdeliveryname" label="送达方" min-width="150"></el-table-column>
        <el-table-column prop="cjhname_list" label="仓库" min-width="95"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closesad()">取 消</el-button>
        <el-button type="success" @click="confirm('assoruleForm')">确 定</el-button>
      </div>
    </el-dialog>
    <operprint v-if="prinpageif" :prinpageif="prinpageif" :prinpagesrc="prinpagesrc" @printclose="printclose" />
  </div>
</template>

<script>
  import operprint from "./Operatiopint";
  import { GetFileType } from "../../../../api/home";
  export default {
    components: { operprint },
    data() {
      return {
        // 当前日期
        nowdate: "",
        // 弹出框的日期
        timeval: [],
        tableorder: [],
        // 公司名称
        selectlist: [],
        tableRadio: {},
        qualiform: { startDate: "", endDate: "" },
        dialogFormVisible: false,
        orderlist: [],
        // 临时存储
        temp: [],
        // 临时存储
        tableordertemp: [],
        prinpageif: false,
        prinpagesrc: "",
        fileListFail: [],
        typeaccept: "",
        formInline: {
          csapcode: "",
          cinvname_list: "",
        },
        previnformdata: {},
      };
    },
    created() {
      if (this.$route.params.tableRadio) {
        this.tableRadio = this.$route.params.tableRadio;
        this.selectlist = this.$route.params.selectlist;
        sessionStorage.setItem("params", JSON.stringify(this.$route.params));
        this.previnformdata = this.$route.params.informdata;
        sessionStorage.setItem(
          "informdata",
          JSON.stringify(this.$route.params.informdata)
        );
        if (this.tableRadio.ddate != "") {
          this.tableRadio.ddate = this.tableRadio.ddate.substring(0, 10);
          console.log(this.tableRadio.ddate);
        }
      } else {
        var params = JSON.parse(sessionStorage.getItem("params"));
        this.tableRadio = params.tableRadio;
        this.selectlist = params.selectlist;
        this.previnformdata = JSON.parse(sessionStorage.getItem("informdata"));
      }
      console.log(this.$route.params, "previnformdata");
      if (this.tableRadio.ddate == "") {
        var myDate = new Date();
        this.tableRadio.ddate =
          myDate.getFullYear() +
          "-" +
          (myDate.getMonth() + 1) +
          "-" +
          myDate.getDate();
      }
      if (this.tableRadio.id != "") {
        this.GetSHDetail();
        this.GetSHInfo();
      }
      this.FileType();
    },
    methods: {
      // 撤销提交
      UnCommitSHInfo() {
        this.$confirm("此操作将撤销提交该条信息，请确认是否操作！！", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$axios({
              method: "post",
              url: "CommonModule/Op_StoreAndInvoice/UnCommitSHInfo",
              data: { KeyValue: this.tableRadio.id },
            }).then((res) => {
              console.log(res);
              if (res.data.Success) {
                this.$message.success(res.data.Message);
                this.GetSHInfo();
                this.GetSHDetail();
              } else {
                this.$message.error(res.data.Message);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除功能",
            });
          });
      },

      // 获取文件类型
      FileType() {
        GetFileType({ type: "02" }).then((res) => {
          console.log(res);
          if (res.data.Success) {
            this.typeaccept = res.data.Data[0].cfileformat;
          }
        });
      },

      //上传文件
      handleChangeFail(file, fileList, index) {
        this.$refs[`uploadFail${index}`].submit();
      },
      // 上传文件
      brforeUploadreImportFail(file, row) {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/SupplierCheckAll",
          data: { cbilltype: "上传校验单", cbillid: row.op_delivery_det_id },
        }).then((res) => {
          console.log(res, "上传结果上传结果上传结果上传结果");

          if (res.data.Success) {
            let varparams = new FormData();
            varparams.append("file", file);
            varparams.append("file", URL.createObjectURL(file));
            varparams.append("cvoucherno", "op_deliveryOrder");
            varparams.append("ctype", "02");
            varparams.append("cvoucherid", row.op_delivery_det_id);
            this.$axios({
              method: "post",
              url: "CommonModule/Op_Supplier/BaseUploadFile",
              headers: { "Content-Type": "multipart/form-data" },
              data: varparams,
              timeout: 30000000,
            }).then((res) => {
              console.log(res, "上传结果");
              if (res.data.Success) {
                this.$message({
                  howClose: true,
                  message: "上传成功",
                  type: "success",
                });
                row.cfileurl = res.data.Data.Path;
                // cfileurl
              } else {
                this.$message.error(res.data.Message);
              }
            });

            return false; //屏蔽了action的默认上传
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      // 获取基本信息
      GetSHDetail() {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_StoreAndInvoice/GetSHDetail",
          data: { KeyValue: this.tableRadio.id },
        }).then((res) => {
          console.log(res, "GetSHDetail");
          if (res.data.Success) {
            this.tableorder = res.data.Data;
            for (var a = 0; a < this.tableorder.length; a++) {
              if (this.tableorder[a].dproducdate != null) {
                this.tableorder[a].dproducdate = this.tableorder[
                  a
                ].dproducdate.substring(0, 10);
              }
              if (this.tableorder[a].dshelfdate != null) {
                this.tableorder[a].dshelfdate = this.tableorder[
                  a
                ].dshelfdate.substring(0, 10);
              }
            }
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      GetSHInfo() {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_StoreAndInvoice/GetSHInfo",
          data: { KeyValue: this.tableRadio.id },
        }).then((res) => {
          console.log(res, "GetSHInfo");
          if (res.data.Success) {
            this.tableRadio = res.data.Data[0];
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      // table tr 选中触发事件
      handleRowClick(row) {
        this.$refs.multipleTable.toggleRowSelection(row);
      },
      // table 选择
      handleSelectionChange(val) {
        console.log(val, "497497469464");
        this.temp = val;
      },
      // 我的订货单
      myorder() {
        if (this.tableRadio.ccorpcode != "") {
          this.GetOrderList();
          this.dialogFormVisible = true;
        } else {
          this.$message.error("请选择公司！");
        }
      },
      // 关闭
      closesad() {
        this.temp = [];
        this.dialogFormVisible = false;
      },
      // 提示框确认
      confirm() {
        this.tableordertemp = [];
        this.tableordertemp = this.temp;
        var arr = [];
        for (var a = 0; a < this.temp.length; a++) {
          arr.push({
            csrminvcode: this.temp[a].csrminvcode_list,
            csapinvcode: this.temp[a].csapinvcode_list,
            cinvname: this.temp[a].cinvname_list,
            cspecification: this.temp[a].cinvstd,
            cunit: this.temp[a].cinvunit,
            cordercode: this.temp[a].csapcode,
            inumber: this.temp[a].inum,
            cdeliverylot: 0,
            cinspection: "",
            dproducdate: "",
            cisuploadtest: this.temp[a].cisuploadtest,
            dshelfdate: "",
            chtcode: this.temp[a].chtcode_list,
            cht_id: this.temp[a].chtid_list,
            cjhname: "",
            cjhcode: "",
            ihg: 0,
            irbjs: 0,
            inohg: 0,
            clifetimeman: "",
            cfactorybatchman: "",
            irkqty: this.temp[a].irkqty,
            inownum: 0,
            clistautoid: this.temp[a].op_purchaseorder_list_autoid,
            cdeliveryname_det: this.temp[a].cdeliveryname,
            cjhname: this.temp[a].cjhname_list,
          });
        }
        this.tableorder = this.unique(arr);
        console.log(this.tableorder);
        setTimeout(() => {
          this.dialogFormVisible = false;
        }, 60);
      },
      unique(arr) {
        // 根据唯一标识orderId来对数组进行过滤
        const res = new Map(); //定义常量 res,值为一个Map对象实例 //返回arr数组过滤后的结果，结果为一个数组   过滤条件是，如果res中没有某个键，就设置这个键的值为1
        return arr.filter(
          (arr) => !res.has(arr.clistautoid) && res.set(arr.clistautoid, 1)
        );
      },
      // 返回
      returnpage() {
        sessionStorage.removeItem("params");
        this.$router.push({
          path: "/Operation_SHOrder/Operation_SHOrder",
          query: { informdata: this.previnformdata },
        });
      },
      //  获取订单列表
      GetOrderList() {
        if (this.timeval != null) {
          if (this.timeval.length != 0) {
            this.qualiform.startDate = this.timeval[0];
            this.qualiform.endDate = this.timeval[1];
          } else {
            this.qualiform.startDate = "";
            this.qualiform.endDate = "";
          }
        } else {
          this.qualiform.startDate = "";
          this.qualiform.endDate = "";
        }
        this.$axios({
          method: "post",
          url: "CommonModule/Op_StoreAndInvoice/GetOrderList",
          data: {
            starttime: this.qualiform.startDate,
            endtime: this.qualiform.endDate,
            cztcode: this.tableRadio.ccorpcode,
            csapcode: this.formInline.csapcode,
            cinvname_list: this.formInline.cinvname_list,
          },
        }).then((res) => {
          console.log(res);
          if (res.data.Success) {
            this.orderlist = res.data.Data;
            this.toggleSelection(this.tableordertemp);
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },

      // 删除
      del(row, i) {
        this.tableorder.splice(i, 1);
        // this.tableordertemp.op_purchaseorder_list_autoid==row.clistautoid
        for (var a; a < this.tableordertemp.length; a++) {
          if (
            this.tableordertemp[a].op_purchaseorder_list_autoid == row.clistautoid
          ) {
            this.tableordertemp.splice(a, 1);
          }
        }
      },
      // 查询是否选中
      toggleSelection(rows) {
        var that = this;
        rows = JSON.parse(JSON.stringify(rows));
        that.$nextTick(() => {
          if (that.$refs.multipleTable) {
            that.$refs.multipleTable.clearSelection();
          }
          var arr = this.orderlist;
          rows.forEach((row) => {
            for (let j in arr) {
              if (
                row.op_purchaseorder_list_autoid ==
                arr[j].op_purchaseorder_list_autoid
              ) {
                // console.log(row)
                that.$refs.multipleTable.toggleRowSelection(arr[j], true);
                break;
              }
            }
          });
        });
      },
      // 保存
      SaveSHInfo() {
        if (this.tableRadio.ciscommit != "是") {
          if (this.tableRadio.ccorpcode != "") {
            for (var a = 0; a < this.selectlist.length; a++) {
              if (this.selectlist[a].ccorpcode == this.tableRadio.ccorpcode) {
                this.tableRadio.ccorpname = this.selectlist[a].ccorpname;
              }
            }
          }
          var KeyValue;
          if (this.tableRadio.id) {
            KeyValue = this.tableRadio.id;
          } else {
            KeyValue = "";
          }
          console.log(this.tableorder, "4144566464645645654654654654");
          if (this.tableorder.length != 0) {
            this.tableorder.forEach((item, index) => {
              let no = index + 1;
              console.log(item.dshelfdate);
              if (item.clifetimeman == "是") {
                if (item.dproducdate == "" || item.dproducdate == null) {
                  this.$message.error("送货单第" + no + "行：请输入生产日期！");
                  throw console.info("信息不完整");
                } else if (item.dshelfdate == "" || item.dshelfdate == null) {
                  this.$message.error("送货单第" + no + "行：请输入保质期！");
                  throw console.info("信息不完整");
                }
              }
              if (item.cfactorybatchman == "是") {
                if (item.cdeliverylot == "" || item.cdeliverylot == null) {
                  this.$message.error("送货单第" + no + "行：请输入送货批次！");
                  throw console.info("信息不完整");
                }
              }

              if (item.inownum == "" || item.inownum == null) {
                this.$message.error("送货单第" + no + "行：请输入本次送货数量！");
                throw console.info("信息不完整");
              }

              // alert(Number(item.inownum));
              // alert(item.irkqty);
              // if (
              //   Number(item.inownum) + Number(item.irkqty) >
              //   Number(item.inumber)
              // ) {
              //   this.$message.error("送货单第" + no + "行：送货数量超出！");
              //   throw console.info("信息不完整");
              // }
            });
            if (this.tableRadio.ddeliverytime == "") {
              this.$message.error("送货日期不能为空！");
              throw console.info("送货日期不能为空！");
            }
            if (this.tableRadio.dyjdeliverytime == "") {
              this.$message.error("预计到货时间不能为空！");
              throw console.info("预计到货时间不能为空！");
            }
            this.$axios({
              method: "post",
              url: "CommonModule/Op_StoreAndInvoice/SaveSHInfo",
              data: {
                KeyValue: KeyValue,
                JsonInfo: JSON.stringify(this.tableRadio),
                JsonDetail: JSON.stringify(this.tableorder),
              },
            }).then((res) => {
              console.log(res);
              if (res.data.Success) {
                this.$message.success(res.data.Message);
                this.tableRadio.id = res.data.Data;
                this.GetSHDetail();
                this.GetSHInfo();
                // this.returnpage();
              } else {
                this.$message.error(res.data.Message);
              }
            });
          } else {
            this.$message.error("请选择我的送货单");
          }
        } else {
          this.$message.error("该订单已提交！");
        }
      },
      CommitSHInfo() {
        console.log(this.tableRadio);
        var keyid;
        if (this.tableRadio.id != "" && this.tableRadio.id != undefined) {
          keyid = this.tableRadio.id;
          if (this.tableRadio.ddeliverytime == "") {
            this.$message.error("送货日期不能为空！");
            throw console.info("送货日期不能为空！");
          }
          if (this.tableRadio.dyjdeliverytime == "") {
            this.$message.error("预计到货时间不能为空！");
            throw console.info("预计到货时间不能为空！");
          }
          if (this.tableorder.length != 0) {
            this.tableorder.forEach((item, index) => {
              let no = index + 1;
              if (item.clifetimeman == "是") {
                if (item.dproducdate == "" || item.dproducdate == null) {
                  this.$message.error("送货单第" + no + "行：请输入生产日期！");
                  throw console.info("信息不完整");
                } else if (item.dshelfdate == "" || item.dshelfdate == null) {
                  this.$message.error("送货单第" + no + "行：请输入保质期！");
                  throw console.info("信息不完整");
                }
              }
              if (item.cfactorybatchman == "是") {
                if (item.cdeliverylot == "" || item.cdeliverylot == null) {
                  this.$message.error("送货单第" + no + "行：请输入批次数量！");
                  throw console.info("信息不完整");
                }
              }
              // if (
              //   Number(item.inownum) + Number(item.irkqty) >
              //   Number(item.inumber)
              // ) {
              //   this.$message.error("送货单第" + no + "行：送货数量超出！");
              //   throw console.info("信息不完整");
              // }
            });
            this.$confirm(
              "此操作将提交送货订单，提交后无法修改信息，请确认是否操作！！",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(() => {
                this.$axios({
                  method: "post",
                  url: "CommonModule/Op_StoreAndInvoice/CommitSHInfo",
                  data: {
                    KeyValue: keyid,
                    JsonInfo: JSON.stringify(this.tableRadio),
                    JsonDetail: JSON.stringify(this.tableorder),
                  },
                }).then((res) => {
                  console.log(res);
                  if (res.data.Success) {
                    this.$message.success(res.data.Message);
                    // this.tableRadio.id = res.data.Data;
                    this.GetSHDetail();
                    this.GetSHInfo();
                    // this.returnpage();
                  } else {
                    this.$message.error(res.data.Message);
                  }
                });
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消提交送货订单",
                });
              });
          }
        } else {
          this.$message.error("请先保存送货单信息");
        }
      },
      // 删除
      DeleteSHInfo() {
        if (this.tableRadio.ciscommit == "是") {
          this.$message.error("送货单已提交！！");
        } else {
          this.$confirm("此操作将删除该条信息，请确认是否操作！！", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$axios({
                method: "post",
                url: "CommonModule/Op_StoreAndInvoice/DeleteSHInfo",
                data: { KeyValue: this.tableRadio.id },
              }).then((res) => {
                console.log(res);
                if (res.data.Code == "1") {
                  this.$message.success(res.data.Message);
                  this.returnpage();
                }
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除功能",
              });
            });
        }
      },
      printclose(val) {
        this.prinpageif = val;
      },

      //打印
      printpage() {
        // var id = "";
        if (this.tableRadio.id == undefined) {
          this.$message.error("请选中要打印的数据！！");
        }
        if (this.tableRadio.id != "") {
          this.prinpagesrc =
            this.global.bxios_URL +
            "CommonModule/PrintView/SetPrintView?KeyValue=" +
            this.tableRadio.id;
          this.prinpageif = true;
        } else {
          this.$message.error("请选中要打印的数据！！");
        }
      },
    },
  };
</script>

<style scoped>
  .itemwidth .el-input {
    width: 160px;
  }

  .itemwidth .el-select {
    width: 160px;
  }

  .cremark .el-input {
    width: 430px;
  }
</style>
<style>
  @media print {
    @page {
      size: landscape;
      /*对打印的尺寸进行设置*/
      margin: 0;
      /*去掉上面的水印*/
    }

    #QR-code .tableinput {
      border: 1px solid #000;
    }
  }
</style>